import script from "./DebtManagementStrategyForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DebtManagementStrategyForm.vue?vue&type=script&setup=true&lang=js"

import "./DebtManagementStrategyForm.vue?vue&type=style&index=0&id=2320740f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2320740f"]])

export default __exports__